import { render, staticRenderFns } from "./ProductsWithoutDeliveryTypes.vue?vue&type=template&id=7327d0d2&scoped=true"
import script from "./ProductsWithoutDeliveryTypes.vue?vue&type=script&lang=ts"
export * from "./ProductsWithoutDeliveryTypes.vue?vue&type=script&lang=ts"
import style0 from "./ProductsWithoutDeliveryTypes.vue?vue&type=style&index=0&id=7327d0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7327d0d2",
  null
  
)

export default component.exports